import * as React from "react";
const SvgChevronRight24Px = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 8, height: 12, fill: "black", viewBox: "0 0 8 12" }, props),
    React.createElement("path", { fill: "current", d: "m8 6-8 5.5V.5L8 6Z" })));
export default SvgChevronRight24Px;
